<template>
  <div
    :class="['ui-icon', `ui-icon__${name}`]"
    :style="styleObj"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

const SIZE_MAP: Record<string, string> = {
  l: '25px',
};

export default defineComponent({
  props: {
    size: {
      type: [Number, String] as PropType<number | string>,
      default: 'l',
    },
    name: {
      type: [String] as PropType<string>,
      required: true,
    },
  },
  computed: {
    styleObj() {
      let size = '0px';
      if (typeof this.size === 'number') {
        size = `${this.size}px`;
      } else if (this.size as string in SIZE_MAP) {
        size = SIZE_MAP[this.size];
      }
      return {
        width: size,
        height: size,
      };
    },
  },
});
</script>

<style lang="scss" src="./scss/index.scss"></style>
